import { Divider, Flex, Text } from '@mantine/core';

import { TimeSlider } from '@/entities/TimeSlider/TimeSlider';

import { SwitchSelector } from '@/shared/uikit/components/input';

const timeItems = [
	{
		label: 'До бронирования',
		value: null,
	},
	{ label: '30 мин', value: 30 },
	{ label: '45 мин', value: 45 },
	{ label: '1 часа', value: 60 },
	{ label: '2 часа', value: 120 },
];

type BookingRadarProps = {
	isRadar: boolean;
	// isAutoBookup: boolean;
	setRadarTime: (time: number) => void;
	setIsRadar: (isRadar: boolean) => void;
	// setIsAutoBookup: (isAutoBookup: boolean) => void;
};

export const BookingRadar = ({
	isRadar,
	setRadarTime,
	setIsRadar,
}: BookingRadarProps) => {
	return (
		<Flex direction="column" gap={24}>
			<Flex bg="#FFECE6" p={16} style={{ borderRadius: '16px' }}>
				<Text fw={600} fz={16} lh={'20px'} c="#FF4405" ta="center">
					На выбранные даты нет свободных мест. Измените даты или включите радар, мы забронируем
					первое освободившееся место
				</Text>
			</Flex>
			<Flex direction="column" gap={16}>
				<SwitchSelector
					name="Радар"
					description="Как только освободится место - сразу пришлем уведомление и забронируем освободившееся место"
					checked={isRadar}
					onChange={setIsRadar}
				/>
				{/*<SwitchSelector*/}
				{/*	name="Автобронирование"*/}
				{/*	description="Сразу забронируем освободившееся место"*/}
				{/*	checked={isAutoBookup}*/}
				{/*	onChange={setIsAutoBookup}*/}
				{/*/>*/}
				<Divider color="#6670851A" />
				<Flex direction="column" justify="space-between" gap={16}>
					<Flex direction="column">
						<Text fz={16} fw={600} lh="20px">
							Время поиска
						</Text>
						<Text c="dimmed" fz={14} fw={500} lh="18px">
							Радар будет включен в течениe:
						</Text>
					</Flex>
					<TimeSlider data={timeItems} setTime={setRadarTime} />
				</Flex>
			</Flex>
		</Flex>
	);
};
